class SaleController {
  constructor(NumberService) {
    this.name = 'sale';
    this.NumberService = NumberService;
    this.matterType = 'real_estate_sale';
    this.stepSelector = 'sale-steps';
    this.pages = [
      { ///////////////////////////////////////////////////////////////////
        pageTitle:'PRICE AND DEPOSIT',
        fields: [
          {
            fieldName: 'Sale Price',
            field: 'price',
            type:'currency',
            required: true,
            value: "0.00",
            hide: (fields) => {
              return false;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'price');
              // valid when price is defined and it is greater than 55000
              return typeof x.value !== 'undefined' && this.NumberService.parseDecimal(x.value) >= 55000;
            },
            invalidText: 'Sale Price must be greater than $55,000.00'
          },
          {
            fieldName: 'Deposit Received',
            field: 'deposit',
            type:'currency',
            required: false,
            value: "0.00",
            hide: (fields) => {
              return false;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'price');
              let y = fields.find(x => x.field === 'deposit');
              // valid if the deposit is not greater than the price
              return this.NumberService.parseDecimal(x.value ? x.value : '') >= this.NumberService.parseDecimal(y.value ? y.value : '');
            },
            invalidText: 'Deposit cannot be greater than the sale price'
          },
        ]
      },
      { ///////////////////////////////////////////////////////////////////
        pageTitle:'REALTOR',
        fields: [
          {
            fieldName: 'Realtor Commission Percentage',
            field: 'realtorCommission',
            type:'number',
            required: false,
            value: 5, step: 0.1,
            hide: (fields) => {
              return false;
            },
            isValid: (fields) => {
            return true;
            }
          }
        ]
      },
      { ///////////////////////////////////////////////////////////////////
        pageTitle:'EXISTING MORTGAGES',
        fields: [
          {
            fieldName: 'Number of Existing Mortgages?',
            field: 'numberExistingMortgages',
            type:'radio',
            class: 'col-6 col-sm-6 col-lg-3 col-md-3 sale-radio-buttons',
            options: [
              { option:'Zero', value: 0},
              { option:'One', value: 1},
              { option:'Two', value: 2},
              { option:'Three', value: 3},
            ],
            required: true,
            hide: (fields) => {
              return false;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'numberExistingMortgages');
              return typeof x.value != 'undefined';
            },
             invalidText: 'numberExistingMortgages'
          },
          {
            fieldName: 'First Mortgage Amount',
            field: 'firstMortgage',
            type:'currency',
            required: true,
            value: "0.00",
            hide: (fields) => {
              // hides this field when the value of the numberExistingMortgages field is zero or undefined
              let x = fields.find(x => x.field === 'numberExistingMortgages');
              return (typeof x.value === 'undefined' || x.value === 0) ;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'numberExistingMortgages');
              if(x.value > 0){
                let y = fields.find( x => x.field === 'firstMortgage');
                return this.NumberService.parseDecimal(y.value ? y.value : '') > 0;
              }
              else {
                return true;
              }
            }
          },
          {
           fieldName: 'Second Mortgage Amount',
           field: 'secondMortgage',
           type:'currency',
           required: true,
            value: "0.00",
           hide: (fields) => {
             // hides this field when the the numberExistingMortgages value is less than 2
             let x = fields.find(x => x.field === 'numberExistingMortgages');
             return (typeof x.value === 'undefined' || x.value <2) ;
           },
           isValid: (fields) => {
              let x = fields.find(x => x.field === 'numberExistingMortgages');
              if(x.value > 1){
                let y = fields.find( x => x.field === 'secondMortgage');
                return x.value > 1 && this.NumberService.parseDecimal(y.value ? y.value : '') > 0;
              }
              else {
                return true;
              }
           }
          },
          {
            fieldName: 'Third Mortgage Amount',
            field: 'thirdMortgage',
            type:'currency',
            required: true,
            value: "0.00",
            hide: (fields) => {
              // hides this field when the the numberExistingMortgages value is less than 3
              let x = fields.find(x => x.field === 'numberExistingMortgages');
              return (typeof x.value === 'undefined' || x.value <3) ;
            },
            isValid: (fields) => {
               let x = fields.find(x => x.field === 'numberExistingMortgages');
               if(x.value > 2){
               let y = fields.find( x => x.field === 'thirdMortgage');
               return this.NumberService.parseDecimal(y.value ? y.value : '') > 0;
               }
               else {
                return true;
               }
            }
          }
        ]
      },
      { ///////////////////////////////////////////////////////////////////
        pageTitle:'EMAIl',
        type:'email', // defines the type of page ( regular, email, end ). The default value is regular
        fields: []
      },
      { ///////////////////////////////////////////////////////////////////
        pageTitle:'CLOSING COST',
        type:'done', // defines the type of page ( regular, email, end ). The default value is regular
        fields: []
      }
    ];
  }
}

SaleController.$inject = ['NumberService'];

export default SaleController;



// WEBPACK FOOTER //
// ./client/app/components/sale/sale.controller.js